export const discountCode = /^[A-Z0-9$%!]+$/i;
